<template>
  <el-dialog
    title="请先完成身份认证"
    :visible="dialogVisible"
    @close="close"
    width="420px"
    append-to-body
  >
    <div class="identity-options">
      <el-radio-group v-model="selected" size="medium">
        <el-radio :label="1">认证为农户</el-radio>
        <el-radio :label="2"
          >认证为新型经营主体 <br /><span
            style="display: inline-block; padding-left: 22px; font-size: 12px"
          >
            (家庭农场、合作社、农业企业等)</span
          ></el-radio
        >
        <el-radio :label="3">认证为集体经济组织</el-radio>
        <el-radio :label="4">认证为农资供应商</el-radio>
      </el-radio-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="confirm" :disabled="!selected"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "IdentitySelectDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      selected: null,
    };
  },
  computed: {
    dialogVisible: function () {
      return this.visible;
    },
  },
  methods: {
    close: function () {
      this.selected = null;
      this.$emit("close");
    },
    confirm: function () {
      if (this.selected) {
        this.$emit("select", this.selected);
        this.selected = null;
        this.$emit("close");
      }
    },
  },
};
</script>

<style scoped>
.identity-options {
  padding: 16px 8px 0 8px;
}

.identity-options .el-radio-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.identity-options .el-radio {
  margin-bottom: 16px;
  margin-right: 0;
  line-height: 1.5;
  align-items: flex-start;
}

.identity-options .el-radio:last-child {
  margin-bottom: 0;
}

.identity-options .el-radio__label {
  line-height: 1.5;
  padding-left: 8px;
}
</style>
